import Triskelion from "./Triskelion";

const ITEMS = [
  "Est. 1982",
  "Peel · Isle of Man",
  "Celtic & Viking Craftsmanship",
  "Archibald Knox Heritage",
  "Hand Finished in Our Workshop",
  "Manx Design",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="relative border-y border-gold/15 bg-ink-2/60 py-5 overflow-hidden" data-testid="heritage-marquee">
      <div className="flex w-max animate-marquee items-center gap-10">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-10">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-10">
                <span className="text-xs uppercase tracking-[0.35em] text-stone-mist whitespace-nowrap">{item}</span>
                <Triskelion className="w-4 h-4 text-gold/60" strokeWidth={9} />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
